module.exports = __webpack_public_path__ + "static/media/noStudyFound.fb084b1d.svg";